export default __webpack_public_path__ + "static/media/Need_help_icon_2.fc69caf5.svg";